module.exports = __webpack_public_path__ + "fa-regular-400.woff2?2379f1c9d0fac6d1ec12b57b60c8fa28";